import { http } from '@/core/helpers/http.helper';
import { ApiResource } from '@/core/models/api-resource.interface';
import { TranslateRequest, TranslateResponse } from './translate.interface';

export class TranslateService {
   async postTranslate(payload: TranslateRequest) {
      const response = await http.post<ApiResource<TranslateResponse>>(`/translations/bulk-translate`, payload);
      return response.data.data;
   }
}
